import styled from 'styled-components';

export const ApplicationMain: any = styled.div` 
// background: red;

.pageContainer{
    margin: 0px 40px;
    padding-top: 50px;
}
.pageContent{
    padding-top: 120px;
}
.contentSection{
    margin: 0px 35px;
}
.pageLink{
    // color: #007bff;
    color: #0099ff;
    cursor: pointer;
}
.btn-blue{
    color: #0099FF;
    font-weight: bold;
    text-transform: initial;
    border-radius: 0px;
    padding: 7px 16px !important;
    min-width: 80px;
    background-color: #fff;
}
.btn-blue:hover{
    background-color: #fff;
}
.btn-blue span, .btn-blue-primary span, .btn-grey-primary span{
    font-size: 14px;
}
button span{
    font-size: 14px;
}
button span a{
    font-size: 14px;
}
.box-red{
    color: rgba(0, 0, 0, 0.87);    
    font-size: 0.875rem;
    min-width: 64px;
    border: 1px solid rgba(0, 0, 0, 0.23);
    padding: 10px 16px;
    // border-radius: 4px;
    text-transform: uppercase;
    // border: 2px solid #f50057;
    // color: #f50057;
    border: 2px solid #cc0000;
    color: #cc0000;
    position: relative;
    bottom: -12px;
}
.btn-blue-primary{
    background-color: #0099FF;
    border-color: #0099FF;
    color: #ffffff;
    font-weight: bold;
    text-transform: initial;
    border-radius: 0px;
    padding: 7px 16px !important;
    min-width: 80px;
}
.btn-grey-primary{
    background-color: #909090;
    border-color: #909090;
    color: #ffffff;
    font-weight: bold;
    text-transform: initial;
    border-radius: 0px;
    padding: 7px 16px !important;
    min-width: 80px;
}
.btn-red-primary{
    // background-color: #c9302c;
    background-color: #cc0000;
    border-color: #cc0000;
    color: #ffffff;
    font-weight: bold;
    text-transform: initial;
    border-radius: 0px;
    padding: 7px 16px !important;
    min-width: 80px;
}
.btn-green-primary{
    // background-color: #4CAF50;
    background-color: #1EB911;
    color: #ffffff;
    border-color: #1EB911;
    font-weight: bold;
    text-transform: initial;
    border-radius: 0px;
    padding: 7px 16px !important;
    min-width: 80px;
}
.btn-black-primary{
    background-color: #000;
    color: #ffffff;
    border-color: #000;
    font-weight: bold;
    text-transform: initial;
    border-radius: 0px;
    padding: 7px 16px !important;
    min-width: 80px;
}

.btn-blue-primary:hover{
    background-color: #0099FF;
}
.btn-green-primary:hover{
    background-color: #1EB911;
}
.btn-black-primary:hover{
    background-color: #000;
}
.btn-grey-primary:hover{
    background-color: #909090;
}
.btn-red-primary:hover{
    background-color:  #cc0000;
}
.clearAllNotification{
    color: #0099FF !important;
    background-color:  #fff !important;
    border-color: #000;
    font-weight: bold;
    text-transform: initial;
    border-radius: 0px;
    padding: 7px 16px !important;
    min-width: 80px;
    margin:10px !important;
}

a{
    color: #0099FF;
}
.strongText{
    font-weight: bold;
}
.textCapital{
    text-transform: uppercase;
}
.text-right{
    text-align: right;
}
.text-center{
    text-align: center;
}
.pull-left{
    float: left;
}
.pull-right{
    float: right;
}
.margin-top-10{
    margin-top:10px;
}
.btn-groups button{
    margin-right: 10px;
    margin-bottom: 10px;
}
.linkRed{
    //color: #e10050;
    color: #cc0000;
}

// Align Left Right CSS
.alignWrapper{
    display: flex;
}
.grow {
    flex-grow: 1;
}
.alignLeft{  
    justify-content:flex-start;
}

.alignRight{
    justify-content:flex-end;
}
.helpIcon{
    color: #aaa;
}
[class*="MuiFormLabel-asterisk-"]{
    color: #cc0000;
}
// div > label > span{
//     color: #cc0000;
// }
.jss1700{
    color: #cc0000;
}
/* // Red Input/DropDown Control */
.redInput{
    // background-color: #cd5c5c;
    color: #fff;
    background-color: #fff;
}
.redInputLabel{
    background-color: #fff;
    color: #cd5c5c;
    // min-height: 25px;
}
.redInputControl{
    color: #fff;
    min-height: 56px;
    background-color: #cd5c5c;
    margin-bottom: 10px;
}
.redInputControl input{
    color: #fff;
}
.ddlRedInput .redInputControl > div{
    padding: 0px 10px;
  }
.redInputControl:before{
  border-bottom: 0px !important;
}
.redInputControl:after{
  border-bottom: 0px !important;
}
.redInputControl:hover, .redInputControl:active{
  background-color: #cd5c5c !important;
}
.redMenuItemClass{
    background-color: #cd5c5c !important;
    color: #ffffff !important;
}
.blueInputControl input{
    color: #fff;
}
.ddlLabel{
//   padding-bottom: 16px;
    padding-bottom: 0px;
}
/* // Red Input/DropDown Control */

/* // Blue Input/DropDown Control */
.blueInput{
    // background-color: #6495ed;
    background-color: #fff;
    color: #fff;
}
.blueInputLabel{
    background-color: #fff;
    color: #6495ed;
    // min-height: 25px;
}
.blueInputControl{
    color: #fff;
    min-height: 56px;
    background-color: #6495ed;
    margin-bottom: 10px;
}
.blueInputControl input{
    color: #fff;
}
.ddlBlueInput .blueInputControl > div{
    padding: 0px 10px;
  }
.blueInputControl:before{
  border-bottom: 0px !important;
}
.blueInputControl:after{
  border-bottom: 0px !important;
}
.blueMenuItemClass{
    background-color: #6495ed !important;
    color: #ffffff !important;
}
/* // Blue Input/DropDown Control */

.autoOperatorSign{
    position: absolute;
    right: 10px;
    top: 40%;
}

// Mixin itself
.clearfix() {
  &:before,
  &:after {
    content: " ";
    display: table;
  }
  &:after {
    clear: both;
  }
}

.clearfix {
    overflow: auto;
  }
  .clearfix::after {
    content: "";
    clear: both;
    display: table;
  }

//Page Pagination CSS
.pagePagination .pagination {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: .25rem;
    margin-top: .5rem;
    margin-bottom: .5rem;
}
.pagePagination .page-item{
    padding: 0px 3px;
}
.pagePagination .page-link {
    position: relative;
    padding: .4rem .75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    // border: 1px solid #dee2e6;
}
.pagePagination .page-link:hover, .pagePagination .page-link.active{   
    text-decoration: none;
    color: #fff !important;
    background-color: #0099ff;
    border-color: #0099ff;
    border-radius: 50%;
}
.pagePagination .page-item:nth-child(n+11) .page-link{
    padding: .4rem .55rem;
}
//Page Pagination CSS

// Page Heading CSS
.pageHeading{
    padding: 20px 0px 5px;
    padding-left: 30px;
    border-bottom: 2px solid #aaa;
    background-color: #ffffff;
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1030;
    margin: 0px 40px;
    top: 50px;
}
.pageHeading .pageTitle{
    margin-top: 10px;
}
.pageHeading .text-right{
    float: right;
}
.pageTitleSection{
    position: relative;
    left: -45px;
    display: flex;
    align-items: self-start;
}
.pageTitleSection .backButton{
    z-index: 1040;
    padding: 12px 12px;
    vertical-align: sub;
    color: #000 !important;
}
.pageTitleSection .pageTitle{
    display: inline-block;
    margin-top: 10px;
    font-size: 24px;
}
.pageTitleSection .headingLink{
    display: inline-block;
    margin-left: 15px;
    margin-top: 15px;
}

.pageTitleSubSection{
    position: relative;
    left: -45px;
    display: flex;
    align-items: self-start;
}
.pageTitleSubSection .pageSubTitle{
    display: inline-block;
    margin-left: 15px;
    font-size: 14px;
}

.surveyReportGridCss{
    margin-top: 10px;
}
.dataEntryPage{
    text-align: right;
    margin-top: 10px;
}

.dataEntryPage a{
    font-size: 18px!important;
    text-decoration: underline;
}

.pageHeadingTitle{
    position: relative;
    left: -30px;
}
.pageHeadingTitle .pageTitle{
    font-size: 30px;
    margin-top: 0px; 
}
// Page Heading CSS

// Page Heading Links CSS
.pagesLinks ul{
    list-style: none;
}
.pagesLinks .listItem{
    display: inline-block;
    padding: 0px 10px;
    border-left: 1px solid #ccc;
}
.pagesLinks .listItem .linkRed{
    // color: #e10050;
    color: #cc0000;
}
.pagesLinks .listItem a{
    color: #0099FF;
    font-size: 18px;
}
.pagesLinks .listItem:first-child{
    border-left: none;
}
// Page Heading Links CSS

//Page Breadcrumb Header CSS
.pageBreadcrumb{
    display: inline-block;
}
.pageBreadcrumb ul{
    list-style: none;
    padding-left: 0px;
    margin: 0px;
}
.pageBreadcrumb .listItem{
    display: inline-block;
    padding: 0px 3px;
}
.pageBreadcrumb .listItem a{
    color: #0099FF;
    cursor: default;
    font-size: 18px !important;
}
.pageBreadcrumb .listItem .active{
    color: #000;
    // font-weight: 600;
}
//Page Breadcrumb Header CSS

//Page Error
.errorMessage{
    //color: #c9302c;
    color: #cc0000;
    margin-top: 5px;
}
//Page Error



//Page Success
.successMessage{
    color: #1EB911;
    margin-top: 5px;
}
//Page Success

// Page popperDropdownMenu
.tooltipPopperWrapper{
    position: relative;
    display: inline-flex;
}
.popperDropdownMenu{
    background-color: #000;
    top: 100%;
    z-index: 1050;
}
.popperDropdownMenuItem{
    color: #fff;
}
.popperDropdownMenuList{
    background-color: #000;
    padding: 0px;
}
.popperDropdownDangerMenuItem .popperDropdownMenuIcon{
    color: #ff0000 !important;
}
.popperDropdownDangerMenuItem .popperDropdownMenuText span{
    color: #ff0000 !important;
    font-weight: 700;
}
.popperDropdownMenuList .popperDropdownMenuIcon{
    color: #fff;
    margin-right: 0px;
}
.popperDropdownMenuList .popperDropdownMenuText span{
    color: #fff;
}
.arrow-up {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 7px 7px 7px;
    border-color: transparent transparent #000000 transparent;
    position: absolute;
    top: -7px;
    right: 10%;
}
// Page popperDropdownMenu

// CSS
.media-list-wrapper .media-list{ 
    padding: 20px 5%;
}
.media-list-wrapper .media-list .media-content{
    width: 100%;
}
.media-list-wrapper .media-list:first-child{
    border-bottom: 2px solid #aaa;
}
.media-list-wrapper .media-list .media-body{
    width: 80%;
}
.media-list-wrapper .media-list .media-body h5{
    margin: 7px 0px;
    display: inline-block;
    font-size: 18px;
}
.media-list-wrapper .media-list .media-body p{
    margin: 15px 0px;
}
.media-list-wrapper .media-list .media-body .captionText{
    text-transform: uppercase;
    font-size: 16px;
    color: #000;
}
.media-list .media-left, .media-list .media-body{
    display: inline-block;
    vertical-align: top;
}
.media-list .media-right{
    display: inline-block;
    padding: 20px 20px;
}
.media-list .media-box{
    padding: 15px 15px;
    margin-right: 15px;
    display: inline-table;
}
.media-box-success{
    color: #449d44;
}
.media-box-primary{
    color: #0099FF;
}
.media-primary{
    color: #0099FF;
}
.media-disable{
    color: #0099FF;
}
.media-na{
    border: 2px solid #aaa;
    border-color: #aaa;
    color: #ccc;
    padding: 5px 5px;
    display: inline-block;
}
.media-module-disable{
    color: #ccc;
}
.media-module-disable *{
    color: #ccc;
}
.media-category-disable *{
    color: #ccc !important;
}
.media-list .media-box.media-box-success{
    border: 2px solid #449d44;
    border-color: #449d44;
    color: #449d44;
}
.media-list .media-box.media-box-primary{
    border: 2px solid #0099FF;
    border-color: #0099FF;
    color: #0099FF;
    display: inline-table;
}
.media-list .media-box.media-disable{
    border: 2px solid #ccc;
    border-color: #ccc;
    // color: #0099FF;
    display: inline-table;
}
.media-list .media-box-large{
    padding: 20px 20px;
}
.media-list .media-box-small{
    padding: 7px 7px;
}
.media-list .media-box.media-primary{   
    color: #0099FF;
    display: inline-table;
}
.media-list .media-box.media-success{   
    color: #449d44;
    display: inline-table;
}
.media-list-width{
        width:100%!important;
        cursor: pointer;        
}

// CSS

// Media Expansion Panel CSS
.media-content-acc-group .MuiExpansionPanelSummary-expandIcon-234{
    color: #0099FF;
}
.media-content-acc-group .ExpansionPanelDetails .media-heading{
    width: 100%;
    text-align: left;
    position: relative;
}
.ExpansionPanelDetails .media-heading .btn-blue-primary{
    position: absolute;
    right: 0px;
    top: 0px;
    border-radius: 0px;
    min-width: 40px !important;
    padding: 10px 7px !important;
}
.ExpansionPanelDetails .media-heading .btn-blue-primary svg{
    font-size: 14px;
    font-weight: bold;
}
.media-content-acc-group .ExpansionPanel{
    box-shadow: none;
    position: relative;
    margin: 20px 0px;
    background: 0px;
}
.media-content-acc-group .ExpansionPanel .progress{
    width: 100%;
    position: absolute;
    padding: 0px;
    bottom: 0px;
    margin-bottom: 0px;
}
.media-content-acc-group .ExpansionPanel .ExpansionPanelSummary{
    padding: 0px;
    position: relative;
}
.media-content-acc-group .MuiExpansionPanelSummary-expandIcon-234{
    color: #0099FF;
}
.media-content-acc-group .ExpansionPanel{
    box-shadow: none;
    position: relative;
    margin: 20px 0px;
    background: 0px;
}
.media-content-acc-group .ExpansionPanel .progress{
    width: 100%;
    position: absolute;
    padding: 0px;
    bottom: 0px;
    margin-bottom: 0px;
}
.media-content-acc-group .ExpansionPanel .ExpansionPanelSummary{
    padding: 0px;
    position: relative;
    margin: 12px 0;
    display: flex;
    width: 100%;
    padding: 15px 0px;
}
.ExpansionPanel .ExpansionPanelSummary .ExpansionPanelSummaryContent{
    margin: 12px 0px;
    display: flex;
    flex-grow: 1;
}
.ExpansionPanelCategory{
    margin: 25px 0px !important;
}
.ExpansionPanelSummaryNone .MuiExpansionPanelSummary-expanded-282{
    margin: 12px 0;
}
.ExpansionPanel .ExpansionPanelSummary .MuiIconButton-root-257{
    color: #0099FF;
}
.ExpansionPanel .ExpansionPanelSummary .media-heading{
    // padding: 10px 15px;
    padding: 10px 50px 10px 15px;
    font-size: 16px;
    width: 100%;
}
.ExpansionPanel:before{
    height: auto;
}
.ExpansionPanel .ExpansionPanelSummary .media-heading p{
    font-size: 18px;
    color: #000;
}
.ExpansionPanel .ExpansionPanelDetails .surveyRedirect .btn-blue-primary{
    border-radius: 0px;
    min-width: 40px !important;
    padding: 10px 7px !important;
    float: right;
}
.ExpansionPanel .ExpansionPanelDetails .surveyRedirect .btn-blue-primary svg{
    font-size: 14px;
    font-weight: bold;
}
.ExpansionPanelDetails .media-box{
    // padding: 3px 3px;
    display: inline-block;
}
.media-insidecontent-acc-group{
    width: 100%;
    margin-left: 6%;
}
.media-insidecontent-acc-group .ExpansionPanelSummary{
    background-color: #e5e5e5;
    padding: 0px;
    min-height: 58px;
}
.media-insidecontent-acc-group .ExpansionPanelSummary .MuiExpansionPanelSummary-content-169{
    margin: 0px 0px;
}
.media-insidecontent-acc-group .ExpansionPanel{
    margin-bottom: 20px;
    border-radius: 0px;
    box-shadow: none; 
}
.media-insidecontent-acc-group .media-content{
    padding: 0px;
}
.media-insidecontent-acc-group .ExpansionPanelSummary .media-content .media-body{
    padding: 0px 20px;
}
.media-insidecontent-acc-group .ExpansionPanelSummary .media-content .media-body h5{
    margin: 15px 0px !important;
}
.media-insidecontent-acc-group .ExpansionPanelSummary [class*="MuiExpansionPanelSummary-content-"]{
    margin: 0px 0px;
}
.media-insidecontent-acc-group .ExpansionPanelSummary > div{
    margin: 0px 0px;
}
.ExpansionPanelSummary [class*="MuiExpansionPanelSummary-expandIcon-"]{
    color: #0099FF !important;
}
.ExpansionPanelSummary .jss1616{
    color: #0099FF !important;
}
.ExpansionPanelSummary > div + div{
    color: #0099FF !important;
}
.ExpansionPanelSummary > div + div svg{
    font-size: 36px;
}
.responseCreated ul{
    list-style: none;
    margin: 0px 0px 5px 0px;
    padding: 0px;
}
.responseCreated ul li{
    display: inline-block;
    padding: 0px 5px;
    border-left: 1px solid #aaa;
}
.responseCreated ul li:first-child{
    border-left: 0px;
}
.red-text{
    font-size: 18px;
    margin: 25px 0px;
}
.media-content-acc-group .[class*="MuiExpansionPanelSummary-expandIcon-"]{
    color: #0099FF;
}
.media-content-acc-group .jss1616{
    color: #0099FF;
}
// Media Expansion Panel CSS

// Progress Bar Dashboard CSS
.progress {
    height: 5px;
    // margin-bottom: 20px;
    overflow: hidden;
    background-color: #f5f5f5;
    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
}
.progress-bar {
    float: left;
    width: 0%;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    background-color: #337ab7;
    -webkit-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    -webkit-transition: width .6s ease;
    -o-transition: width .6s ease;
    transition: width .6s ease;
}
.progress-bar-success {
    background-color: #5cb85c;
    // width: 100%;
}
.progress-bar-primary {
    background-color: #0099FF;
    width: 50%;
}
// Progress Bar Dashboard CSS

// Kendo Custom CSS
.kendoWrapper .k-widget{
    border: 0px;
}
.kendoWrapper .k-header{
    border: 0px;
}
.kendoWrapper .k-grid td{
    // border: 0px;
    border-top: 1px solid #aaa;
    border-width: 1px 0 0 0px;
    padding: 7px 12px;
    color: #000;
    font-size: 14px;
}
.kendoWrapper .k-grid td.title{
    font-size: 18px;
    color: #000;
}
.kendoWrapper .k-grid-header-wrap{
    border: 0px;
}
.kendoWrapper .k-grid-header-wrap tr th.k-header{
    border-top: 2px solid #aaa;
}
.kendoWrapper .k-grid-header-wrap tr th.k-header:last-child{
    text-align: center;
}
.kendoWrapper .k-grid tr.k-alt{
    background-color: #ffffff;
}
.kendoWrapper .k-filter-row td, .k-filter-row th{
    border: 0px;
}
.kendoWrapper .k-grid thead{
    border-top: 1px solid #aaa;
    border-bottom: 1px solid #aaa;
    background-color: #fff;
}
.kendoWrapper .k-grid-container{
    border-top: 1px solid #aaa;
}
.kendoWrapper .k-grid-content{
    overflow-y: auto;
}
.kendoWrapper .k-grid-content .k-grid-table{
    min-height: 100px;
}
.kendoWrapper .k-grid-header{
    padding: 0px !important;
}
.kendoWrapper .k-pager-numbers .k-link{
    position: relative;
    padding: .4rem .75rem;
    margin-left: -1px;
    margin: 0px 3px;
    line-height: 1.25;
    color: #007bff;
    // background-color: #fff;
}
.kendoWrapper .k-pager-numbers .k-link:hover, .kendoWrapper .k-pager-numbers .k-link.k-state-hover{
    background-color: #007bff;
    border-radius: 50%;
    color: #fff !important;
}
.kendoWrapper .k-pager-numbers .k-state-selected{
    -webkit-text-decoration: none;
    text-decoration: none;
    color: #fff !important;
    background-color: #007bff;
    border-color: #007bff;
    border-radius: 50%;
}
.kendoWrapper .actions{
    text-align: center;
}
.kendoWrapper .k-grid td .btn-blue-primary span, .kendoWrapper .k-grid td .btn-green-primary span, .kendoWrapper .k-grid td .btn-grey-primary span, .kendoWrapper .k-grid td .btn-red-primary span, .kendoWrapper .k-grid td .btn-black-primary span{
    font-weight: 500;
}
.kendoWrapper .k-filtercell .k-filtercell-wrapper>.k-textbox{
    border-radius: 50px;
    background-color: #E5E5E5;
}
.kendoWrapper .k-filtercell-operator .k-dropdown-operator{
    border-radius: 50px;
    background-color: #fff;
    border: 0px;
}
.kendoWrapper .k-filtercell-operator .k-dropdown-operator .k-select{
    background-color: #fff;
}
.kendoWrapper .k-filtercell-wrapper .k-dropdown .k-dropdown-wrap{
    border-radius: 50px;
    background-color: #E5E5E5;
}
.kendoWrapper .k-pager-wrap .k-pager-nav:hover {
    color: #fff;
    background-color: #007bff;
    border-radius: 50%;
}
.kendoWrapper .k-grid-header .k-header>.k-link{
    color: #000;
}
// Kendo Custom CSS

// Editor CSS
.text-editor-wrapper.rdw-editor-wrapper{
    margin-top: 50px;
}
.text-editor.rdw-editor-main{
    border-bottom: 1px solid #aaaaaa;
}
.text-editor.rdw-editor-main:focus{
    border-bottom: 1px solid #0099FF;
}
.text-editor .public-DraftStyleDefault-block{
    margin: 0px 0px;
}
.text-editor .DraftEditor-editorContainer{
    padding: 7px 0px;
}
.text-editor div ul li, .text-editor div ol li{
    padding: 5px 0px;
}
// Editor CSS

// Toastify CSS
.Toastify .Toastify__toast{
    position: relative;
}
.Toastify .Toastify__toast .Toastify__toast-body{
    font-weight: bold;
}
.Toastify .Toastify__close-button{
    position: absolute;
    z-index: 99;
    right: 15px;
    top: 35%;
    color: #ffffff;
    opacity: 1;
}
// Toastify CSS

// Page Footer CSS
.footerSection{
    display:-webkit-flex;
    display:flex;
    padding: 20px 0px;
    border-top: 2px solid #aaa;
}
.footerSection.submitSurvey {
    position: relative;
    top: 165px;
    border-top: 2px solid #ccc;
}
.footerSection.submitSurvey .btn-blue {
    color: white;
    font-weight: bold;
    text-transform: initial;
    border-radius: 0px;
    background: #0099FF;
}
.footerSection .grow {
    flex-grow: 1;
}
.footerSection .alignLeft{  
    justify-content:flex-start;
}

.footerSection .alignRight{
    justify-content:flex-end;
}
// Page Footer CSS
.submitSurveyDisclaimer{
    color: #cc0000;
    background-color: #f8cbcb;
    border-color: #f8cbcb;
    padding: 7px 15px;       
    border: 1px solid transparent;
    border-radius: 4px;
    position: relative;
    left: 0%;
    top: 15%;       
    margin: 0 auto;
    font-size: 16px;
    text-align: center;
}

.CustomCss{
    background-color: rgb(229, 229, 229);
    padding:2px;
    
}

.CustomCssForReports{
    background-color: rgb(229, 229, 229);
    position: absolute;
  right: 70px;
  width: 150px;
  border: 3px solid #0099FF;
  cursor: pointer;
  height: 30px;
}
.buttonDisabled{
    background-color:#CCC!important;
}
.DeletePageAlign
{    vertical-align: middle;
    padding-top: 10px;
    text-align: center;
}

.DeleteClusterAlign{
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    flex-direction: column;
    align-content: center;
}   
`;



// WEBPACK FOOTER //
// ./src/styles/common.tsx